import { motion } from "framer-motion";
import {
  Wallet,
  ProhibitInset,
  Lightning,
  ShieldCheck,
  Stack,
  CurrencyCircleDollar,
} from "@phosphor-icons/react";

const EASE = [0.16, 1, 0.3, 1];

const FEATURES = [
  { Icon: Wallet, title: "Wallet-first", body: "Move funds between the wallets you already use.", id: "wallet-first" },
  { Icon: ProhibitInset, title: "No copy & paste", body: "Forget long wallet addresses and QR codes.", id: "no-copy" },
  { Icon: Lightning, title: "Fast", body: "Deposit stablecoins in just a few taps.", id: "fast" },
  { Icon: ShieldCheck, title: "Secure", body: "Transfers are authorized directly from your wallet.", id: "secure" },
  { Icon: Stack, title: "Multi-wallet", body: "Works across supported wallets and networks.", id: "multi-wallet" },
  { Icon: CurrencyCircleDollar, title: "Built for stablecoins", body: "Designed for modern digital money.", id: "stablecoins" },
];

export default function WhyOpenDeposit() {
  return (
    <section id="why" data-testid="why-section" className="relative bg-white py-20 md:py-24">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="max-w-2xl">
          <p className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-zinc-500">
            <span className="h-1.5 w-1.5 rounded-full bg-[#f5d949]" />
            Why OpenDeposit
          </p>
          <h2 className="mt-4 font-display font-black tracking-[-0.02em] leading-[0.95] text-3xl md:text-5xl">
            Built for the way money should move.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {FEATURES.map((f, i) => (
            <motion.div
              key={f.id}
              data-testid={`feature-${f.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, ease: EASE, delay: (i % 3) * 0.06 }}
              className="group rounded-2xl border border-black/10 bg-[#f6f6f7] p-6 hover:border-[#f5d949] hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#f5d949]">
                <f.Icon size={22} weight="bold" className="text-black" />
              </div>
              <h3 className="mt-5 font-display text-xl font-bold">{f.title}</h3>
              <p className="mt-2 text-sm text-zinc-600 leading-relaxed">{f.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
